namespace $ {

	export class $shm_ba_dashboard_model extends $mol_object2 {

		record() {
			return null as $shm_ba_pb_file_record | null
		}

		collection() {
			return 'user_dashboards'
		}

		id() {
			return this.record()?.id ?? 'default'
		}

		title() {
			const record = this.record()
			if( !record ) return 'Default'

			return String(
				record.title
				?? record.name
				?? record.label
				?? record.id
			)
		}

		visible_tags() {
			const value = this.record()?.visible_tags
			if( value == null ) return null
			return Array.isArray( value ) ? value.map( String ) : null
		}

		excluded_tags() {
			const value = this.record()?.excluded_tags
			return Array.isArray( value ) ? value.map( String ) : []
		}

		files() {
			const record = this.record()
			if( !record ) return [] as $shm_ba_pb_file_item[]

			const files = [] as $shm_ba_pb_file_item[]

			for( const file_record of this.$.$shm_ba_pb.records_filtered( `dashboard_files\ndashboard = "${ record.id }"` ) ) {
				for( const file of this.$.$shm_ba_pb.record_files( file_record, 'file' ) ) {
					const uri = this.$.$shm_ba_pb.file_uri( file_record, 'dashboard_files', file )
					files.push({
						id: uri,
						title: String( file_record.title || file_record.id ),
						uri,
						created: String( file_record.created ?? '' ),
						updated: String( file_record.updated ?? '' ),
					})
				}
			}

			return files.sort( ( left, right )=> {
				const left_date = left.created || left.updated || ''
				const right_date = right.created || right.updated || ''
				if( left_date !== right_date ) return right_date.localeCompare( left_date )

				return left.title.localeCompare( right.title )
			} )
		}

		opencode_session_id( next?: string ) {
			const record = this.record()
			if( !record ) return ''
			if( next !== undefined ) {
				this.opencode_session_id_cached( next )
				this.opencode_session_id_stored( next )
				this.opencode_session_id_save( record.id, next )
				return next
			}
			const cached = this.opencode_session_id_cached()
			if( cached !== null ) return cached
			return String( record.opencode_session_id || this.opencode_session_id_stored() || '' )
		}

		@ $mol_mem
		opencode_session_id_cached( next?: string | null ) {
			return next ?? null
		}

		opencode_session_id_stored( next?: string ) {
			const record = this.record()
			if( !record ) return ''
			return this.$.$mol_state_local.value< string >( `hitalama_ba_dashboard_opencode_session_id:${ record.id }`, next ) ?? ''
		}

		@ $mol_action
		opencode_session_id_save( id: string, next: string ) {
			$mol_wire_async( this.$.$shm_ba_pb ).update_record(
				'user_dashboards',
				id,
				{ opencode_session_id: next },
			).catch( error => $mol_fail_log( error ) )
		}

		@ $mol_mem
		static records() {
			const user = this.$.$shm_ba_pb.user_id()
			if( this.$.$shm_ba_pb.auth_user_token() && !user ) return [] as readonly $shm_ba_pb_file_record[]

			const records = user
				? this.$.$shm_ba_pb.records_filtered( `user_dashboards\nuser.id ?= "${ this.$.$shm_ba_pb.filter_text( user ) }"` )
				: this.$.$shm_ba_pb.records( 'user_dashboards' )

			return [ ... records ].sort( ( left, right )=> {
				const left_sort = Number( left.sort ?? 0 )
				const right_sort = Number( right.sort ?? 0 )
				if( left_sort !== right_sort ) return left_sort - right_sort

				return String( left.title ?? left.id ).localeCompare( String( right.title ?? right.id ) )
			} )
		}

		@ $mol_mem_key
		static user_ids( id: string ) {
			const value = this.records().find( record => record.id === id )?.user
			if( Array.isArray( value ) ) return value.map( String ).filter( Boolean )
			return value ? [ String( value ) ] : []
		}

		@ $mol_mem_key
		static item( id: string ) {
			const obj = new this.$.$shm_ba_dashboard_model()
			const record = this.records().find( record => record.id === id ) ?? null
			obj.record = ()=> record
			obj.collection = ()=> record?.collectionName || 'user_dashboards'
			return obj
		}

		@ $mol_mem
		static list() {
			const records = this.records()
			if( !records.length ) {
				if( this.$.$shm_ba_pb.auth_user_token() ) return []
				return [ this.item( 'default' ) ]
			}

			return records.map( record => this.item( record.id ) )
		}

	}

}
